"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingDirectory = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SettingDirectoryWrap_1 = require("./SettingDirectoryWrap");
var index_1 = require("../../index");
function SettingDirectory(props) {
    var data = props.data;
    return (React.createElement(index_1.ThemeWrap, null,
        React.createElement(SettingDirectoryWrap_1.SettingDirectoryWrap, { data: data })));
}
exports.SettingDirectory = SettingDirectory;
//# sourceMappingURL=index.js.map